import { useEffect, useState } from "react";

// Breakpoints alignes avec index.css (--breakpoint-md / --breakpoint-lg)
export const MOBILE_MAX = 769;
export const TABLET_MAX = 989;

function useMatchMedia(query: string): boolean {
  const [matches, setMatches] = useState<boolean>(() => {
    if (typeof window === "undefined") return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === "undefined") return;
    const mql = window.matchMedia(query);
    const handler = (e: MediaQueryListEvent) => setMatches(e.matches);
    // eslint-disable-next-line react-hooks/set-state-in-effect -- sync immediate au cas ou la query change ou ou matches a evolue entre mount et effet
    setMatches(mql.matches);
    mql.addEventListener("change", handler);
    return () => mql.removeEventListener("change", handler);
  }, [query]);

  return matches;
}

export function useIsMobile(): boolean {
  return useMatchMedia(`(max-width: ${MOBILE_MAX}px)`);
}

// Viewport compact : mobile portrait OU mobile paysage (height faible).
// Utilise pour les modales : un Dialog centre sur 812x375 (iPhone paysage) est inutilisable,
// alors qu'un Drawer plein-largeur reste exploitable.
export function useIsCompactViewport(): boolean {
  return useMatchMedia(`(max-width: ${MOBILE_MAX}px), (max-height: 599px)`);
}
